<!-- 抽奖结果 -->

<template>
    <views class="prize-result">
        <images :src="imgs.bg"></images>
        <views class="prize-result-content">
            <views class="con">
                <images :src="imgs.contentBg"></images>
                <views class="inner">
                    <views class="c">
                        <views class="li">
                            <images :src="giftIcon"></images>
                        </views>
                        <views class="li title">{{ winTitle }}</views>
                        <views class="li name">{{ winName }}</views>
                        <views class="btn">
                            <button class="primary" @click="handlePrize">继续抽奖</button>
                        </views>
                        <views class="btn" >
                            <button @click="handleHome">返回首页</button>
                        </views>
                    </views>
                </views>
            </views>
            <views v-if="!isRedPacket && result.isWin" class="addr">
                <images :src="imgs.addressBg"></images>
                <views class="inner">
                    <views class="c">
                        <views class="addr-list">
                            <input v-model="form.real_name" type="text" placeholder="请输入收货人">
                        </views>
                        <views class="addr-list">
                            <input v-model="form.phone" type="number" pattern="[0-9]*" placeholder="请输入联系电话">
                        </views>
                        <views class="addr-list">
                            <input v-model="form.address" type="text" placeholder="请输入联系地址">
                        </views>
                        <views class="addr-list">
                            <button @click="handleSubmit">提交</button>
                        </views>
                    </views>
                </views>
            </views>
        </views>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
import address from '@/mixins/address'
import api from '@/utils/api'
export default {
    mixins: [tools, address],
    props: {
        imgs: {
            type: Object,
            default: () => ({})
        },
        result: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                receiver_address: this.getAddress || '',
                address: ''
            }
        }
    },
    computed: {
        winTitle() {
            return this.result.isWin ? '恭喜您，中奖啦！' : '很遗憾，您没有中奖！'
        },
        winName() {
            return this.isRedPacket
                //  TODO 1230:1 固定红包显示时注释的*** ? `${this.result.gift_name} ${this.result.red_packet_amount} 元`
                ? `${this.result.gift_name}`
                : this.result.gift_name
                    ? this.result.gift_name
                    : '很遗憾再接再厉'
        },
        giftIcon() {
            return this.result.giftIcon
        },
        isRedPacket() {
            return this.result.red_packet_amount > 0
        }
    },
    mounted() {
        api.getUserInfo().then((res) => {
            if (res) {
                Object.keys(res.data).forEach(key => {
                    if (key !== 'address') {
                        this.$set(this.form, key, this.form[key])
                    }
                })
                this.$set(this.form, 'address', res.data.address.address)
            }
        })
    },
    methods: {
        handleHome() {
            // this.push('/')
            this.replace('/')
        },
        handlePrize() {
            // this.$emit('continuePrize')
            // this.scrollToTop()
            this.replace('/scan-code?type=prize&public=1')
            // this.push('/verify?type=prize&public=1')
        },
        handleSubmit() {
            this.$emit('saveAddrs', this.form)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
